import { Stack as StackMui } from '@mui/material';
import { styledWithLayoutProps } from '../../utils/styled-with-layout-props';

export const StyledStackMui = styledWithLayoutProps(StackMui);
